export const SEARCH_STUDENTS_LABEL = 'Search Students';
